import { render, staticRenderFns } from "./MobilePhonesStandalone.vue?vue&type=template&id=107e6f7c&"
import script from "./MobilePhonesStandalone.vue?vue&type=script&lang=js&"
export * from "./MobilePhonesStandalone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports